import api from '@/services/api/config';

import eingabeart from './eingabeart';
import pruefaktion from './pruefaktion';
import status from './status';
import pruefmerkmalvorlage from './pruefmerkmalvorlage';
import admin from './admin';

const path = 'v1/wareneingangspruefung';

export default {
  getProtocols: (
    statusParam,
    artikelnummer,
    page,
    size,
    sort = null,
    desc = false,
    suche = null,
  ) => api.get(`${path}/protocol`, {
    params: {
      status: statusParam, artikelnummer, page, size, sort, desc, suche,
    },
  }),
  getById: (id) => api.get(`${path}/${id}`),
  get: (statusParam, artikel, finishedBefore, warenannahme, page, size, sort = null, desc = false, suche = null) => api.get(path, {
    params: {
      status: statusParam, artikel, finished_before: finishedBefore, warenannahme, page, size, sort, desc, suche,
    },
  }),
  create: (wareneingangspruefung) => api.post(path, wareneingangspruefung),
  update: (id, wareneingangspruefung) => api.put(`${path}/${id}`, wareneingangspruefung),
  abschliessen: (id, { warenannahme, reason }) => api.patch(`${path}/${id}/abschliessen`, { warenannahme, reason }),
  eingabeart,
  pruefaktion,
  status,
  pruefmerkmalvorlage,
  admin,
};
